import { useLanguage } from "@/iti-core-react/hooks/useLanguage.ts";
import SupportPopup from "@/pages/Support/components/SupportPopup/SupportPopup.tsx";
import { useCallback, useState } from "react";
import "./SupportButton.scss";

export default function SupportButton() {
	const { t } = useLanguage();
	const [showSupportPopup, setShowSupportPopup] = useState(false);

	const handleSupportClick = useCallback(() => {
		setShowSupportPopup(true);
	}, []);

	const handleHideSupportPopup = useCallback(() => {
		setShowSupportPopup(false);
	}, []);

	return (
		<>
			<div className="support-button-container compact">
				{showSupportPopup && (
					<SupportPopup
						visible={showSupportPopup}
						onHide={handleHideSupportPopup}
					/>
				)}
				<button
					type="button"
					className="support-chat-button compact"
					onClick={handleSupportClick}
					title={t("support.title")}
					aria-label={t("support.title")}
				>
					<i className="mdi mdi-face-agent support-icon" />
				</button>
			</div>
		</>
	);
}
